import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";

const LANGUAGE_STORAGE_KEY = "app_lang";
const NAMESPACES = [
  "common",
  "order",
  "kitchen",
  "terminal",
  "admin",
  "reports",
  "landing",
] as const;

type SupportedLng = "en" | "sv";
type Namespace = (typeof NAMESPACES)[number];

const localeLoaders: Record<
  SupportedLng,
  Record<Namespace, () => Promise<unknown>>
> = {
  en: {
    common: () => import("@/locales/en/common.json"),
    order: () => import("@/locales/en/order.json"),
    kitchen: () => import("@/locales/en/kitchen.json"),
    terminal: () => import("@/locales/en/terminal.json"),
    admin: () => import("@/locales/en/admin.json"),
    reports: () => import("@/locales/en/reports.json"),
    landing: () => import("@/locales/en/landing.json"),
  },
  sv: {
    common: () => import("@/locales/sv/common.json"),
    order: () => import("@/locales/sv/order.json"),
    kitchen: () => import("@/locales/sv/kitchen.json"),
    terminal: () => import("@/locales/sv/terminal.json"),
    admin: () => import("@/locales/sv/admin.json"),
    reports: () => import("@/locales/sv/reports.json"),
    landing: () => import("@/locales/sv/landing.json"),
  },
};

void i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend((lng: string, ns: string) => {
      if (
        !["en", "sv"].includes(lng) ||
        !NAMESPACES.includes(ns as Namespace)
      ) {
        return Promise.resolve({});
      }
      return localeLoaders[lng as SupportedLng][ns as Namespace]();
    })
  )
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "sv"],
    defaultNS: "common",
    ns: NAMESPACES,
    partialBundledLanguages: true,
    load: "currentOnly",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export { LANGUAGE_STORAGE_KEY };
export default i18n;
